import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Image from './../Image'
import bemClass from './../../utils/bemClass'

import './Loader.css'

const cn = bemClass('Loader')

class Loader extends PureComponent {
    render() {
        const { className } = this.props

        return (
            <div className={`${cn()} ${className}`}>
                <Image
                    src={'kawiarnia__karrot__logo.png'}
                    width={300}
                    containerClassName={cn('logo')}
                    alt="logo"
                    noBlurUp
                />
            </div>
        )
    }
}

Loader.propTypes = {
    className: PropTypes.string,
}

Loader.defaultProps = {
    className: '',
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.jsx